import { AddVehicleFormData } from './AddVehicleModal'



export const mapStateToApiVariable = (state: AddVehicleFormData): AddVehicleFormData => {
  return {
    vehicle_type_id: state.vehicle_type_id,
    license_plate: state.license_plate,
    vin: state.vin,
    model: state.model,
    brand: state.brand,
    year: Number(state.year),
    color: state.color,
    capacity_kg: Number(state.capacity_kg),
    capacity_m3: Number(state.capacity_m3),
    temp_max_c: Number(state.temp_max_c),
    temp_min_c: Number(state.temp_min_c),
    range_km: Number(state.range_km),
    average_speed: Number(state.average_speed),
    is_active: state.is_active,
    comment: state.comment
  }
}